import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiVersions } from 'src/app/shared/services/api-version';
import { BaseService } from './base.service';
import { Eula } from '../models/eula';
import { HttpGetOptions } from '../types/http-get-options.type';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SystemUserEulaService extends BaseService {
  private readonly basePath = 'eulas';
  private attemptedRoute: string = '';
  public hasLoggedInSystemUserAcceptedLatestEula = new BehaviorSubject<boolean>(null);
  public latestEulaInEffect = new Subject<Eula>();

  constructor() {
    super();
  }

  public get_has_logged_in_system_user_accepted_latest_eula() {
    let obs = this.get(`${this.basePath}/accepted-latest`, null, ApiVersions.unversioned);
    obs.subscribe((hasAcceptedLatestEula) => {
      this.hasLoggedInSystemUserAcceptedLatestEula.next(hasAcceptedLatestEula);
    });
    return obs;
  }

  public getEulaFile() {
    return this.getFile(`${this.basePath}/latest-file`, ApiVersions.unversioned);
  }

  public get_latest_eula() {
    return this.get(`${this.basePath}/latest`, null, ApiVersions.unversioned)
      .pipe(
        map((result) => {
          if (result) {
            return Eula.parse(result);
          }
        })
      )
      .subscribe((latestEula) => {
        this.latestEulaInEffect.next(latestEula);
      });
  }

  public accept_eula(eula: Eula) {
    let body = JSON.stringify(eula);
    return this.post(`${this.basePath}`, body, null, ApiVersions.unversioned, true).subscribe(
      () => {
        this.hasLoggedInSystemUserAcceptedLatestEula.next(true);
        this.get_latest_eula();
        this.openSnackBar('Thank you for accepting the Lineup End User Licensing Agreement.', true);
        this.redirectToAttemptedRoute();
      },
      (err) => {
        this.openSnackBar(
          'There was an error when attempting to accept the Lineup End User Licensing Agreement.',
          false
        );
      }
    );
  }

  public redirectToAttemptedRoute() {
    if (this.attemptedRoute && this.hasLoggedInSystemUserAcceptedLatestEula) {
      let redirect = this.attemptedRoute;
      this.resetAttemptedRoute();
      this.goToRoute(redirect);
    }
  }

  public get AttemptedRoute(): string {
    return this.attemptedRoute;
  }

  public setAttemptedRoute(attemptedRoute: string) {
    if (attemptedRoute !== '/home') {
      this.attemptedRoute = attemptedRoute;
    }
  }

  public resetAttemptedRoute() {
    this.attemptedRoute = '';
  }
}
